import hark from 'hark'
import {Ref} from "@vue/composition-api"

export function detectSpeaker(mediaStream: MediaStream, isSpeaking: Ref<boolean>) {
  const speaker: hark.Harker = hark(mediaStream)
  speaker.on('speaking', () => {
    isSpeaking.value = true
  })
  speaker.on('stopped_speaking', () => {
    isSpeaking.value = false
  })
}
